/* FSA Immersive Desktop Experience
   Scroll zoom, parallax, section reveals, 3D card tilt, cursor glow */
(function () {
  'use strict';
  if (window.innerWidth < 990) return;

  /* 1. Scroll Progress Bar */
  var bar = document.createElement('div');
  bar.id = 'fsa-progress';
  document.body.prepend(bar);

  /* 2. Cursor Glow */
  var glow = document.createElement('div');
  glow.id = 'fsa-cursor-glow';
  glow.style.cssText = 'left:-999px;top:-999px;';
  document.body.appendChild(glow);
  document.addEventListener('mousemove', function (e) {
    glow.style.left = e.clientX + 'px';
    glow.style.top  = e.clientY + 'px';
  });

  /* 3. Mark sections for scroll reveal */
  function initReveal() {
    document.querySelectorAll('.shopify-section').forEach(function (s, i) {
      if (i === 0) return;
      if (!s.classList.contains('fsa-reveal')) s.classList.add('fsa-reveal');
    });
  }
  initReveal();

  /* 4. 3D Card Tilt on hover */
  function initTilt() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.dataset.fsaTilt) return;
      card.dataset.fsaTilt = '1';
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width  - 0.5) * 14;
        var y = ((e.clientY - r.top)  / r.height - 0.5) * -14;
        card.style.transform   = 'perspective(800px) rotateY('+x+'deg) rotateX('+y+'deg) translateZ(10px) scale(1.02)';
        card.style.boxShadow   = (-x*1.2)+'px '+(y*1.2)+'px 28px rgba(0,0,0,0.13)';
        card.style.transition  = 'transform 0.08s ease, box-shadow 0.08s ease';
        card.style.zIndex      = '2';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform  = '';
        card.style.boxShadow  = '';
        card.style.transition = 'transform 0.4s ease, box-shadow 0.4s ease';
        card.style.zIndex     = '';
      });
    });
  }
  initTilt();
  setTimeout(initTilt, 2500);
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initTilt();
  });

  /* 5. Main Scroll Handler: progress + parallax/zoom + reveal */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var st        = window.scrollY;
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;

      /* Progress bar */
      bar.style.width = Math.min(100, st / maxScroll * 100).toFixed(1) + '%';

      /* Parallax + zoom on image-with-text and banner sections */
      document.querySelectorAll('.image-with-text__media, .banner__media').forEach(function (el) {
        var rect  = el.getBoundingClientRect();
        var inView = rect.bottom > 0 && rect.top < window.innerHeight;
        if (!inView) return;
        var pct      = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        var clamped  = Math.max(0, Math.min(1, pct));
        var parallax = (clamped - 0.5) * 70;        /* ±35px vertical shift */
        var zoom     = 1.04 + clamped * 0.07;       /* scale 1.04 → 1.11   */
        el.style.transform = 'translateY('+parallax.toFixed(1)+'px) scale('+zoom.toFixed(3)+')';
      });

      /* Section reveal */
      document.querySelectorAll('.fsa-reveal:not(.fsa-revealed)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.87) {
          el.classList.add('fsa-revealed');
        }
      });

      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  setTimeout(onScroll, 200);

})();
